/* HI BAGS USA – rotates the 4 displayed New Arrivals every 24 hours.
   UTC midnight defines a stable 24-hour interval (no DST anomalies).
   Only genuine Shopify collection products are used. */
(() => {
  if (window.__hibagsDailyArrivalsInstalled) return;
  window.__hibagsDailyArrivalsInstalled = true;
  const DAY_MS = 86400000;
  let timer;

  function refresh() {
    const dayNumber = Math.floor(Date.now() / DAY_MS);
    document.querySelectorAll('[data-hb-daily-arrivals="true"]').forEach(section => {
      const cards = Array.from(section.querySelectorAll('.hb-daily-arrivals__product'));
      if (cards.length === 0) return;
      const visibleCount = Math.min(4, cards.length);
      const windows = Math.ceil(cards.length / visibleCount);
      const start = (dayNumber % windows) * visibleCount;
      const active = new Set(Array.from({length: visibleCount}, (_, i) => (start + i) % cards.length));
      cards.forEach((card, index) => {
        card.classList.toggle('hb-daily-arrivals--active', active.has(index));
      });
      section.classList.add('hb-daily-arrivals--ready');
      section.dataset.hbDailyDay = String(dayNumber);
    });
    clearTimeout(timer);
    const msUntilNextDay = DAY_MS - (Date.now() % DAY_MS) + 250;
    timer = setTimeout(refresh, msUntilNextDay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, {once:true});
  } else {
    refresh();
  }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh();
  });
})();
